import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { MartBreakdownRow } from 'src/redux/admin/mart-reporting/mart-reporting.types';
import {
  BreakdownKind,
  formatBreakdownValue,
} from 'src/pages/reports/utils/format-reporting-labels';
import { BetaChartCard } from './beta-chart-card';
import { BetaBreakdownBarsSkeleton } from './beta-chart-skeletons';
import { BetaChartTooltip } from './beta-chart-tooltip';

interface BetaBreakdownChartProps {
  title: string;
  subtitle?: string;
  data: MartBreakdownRow[];
  breakdownField?: string;
  breakdownKind?: BreakdownKind;
  /** @deprecated Use breakdownField */
  geoField?: string;
  metricKey?: string;
  colour?: string;
  isLoading?: boolean;
}

export function BetaBreakdownChart({
  title,
  subtitle,
  data,
  breakdownField,
  breakdownKind = 'geo',
  geoField,
  metricKey = 'impressions',
  colour = '#2563EB',
  isLoading = false,
}: BetaBreakdownChartProps) {
  const field = breakdownField ?? geoField ?? '';

  const chartData = data
    .slice(0, 10)
    .map((row) => {
      const rawKey = String(row.key ?? '');
      return {
        rawKey,
        label: formatBreakdownValue(breakdownKind, field, rawKey),
        value: Number(row[metricKey] ?? 0),
      };
    })
    .filter((row) => row.rawKey);

  return (
    <BetaChartCard title={title} subtitle={subtitle}>
      {isLoading ? (
        <div className="flex min-h-[260px] items-center">
          <BetaBreakdownBarsSkeleton colour={colour} />
        </div>
      ) : chartData.length === 0 ? (
        <div className="flex h-[260px] items-center justify-center text-sm text-[#8A8EA0]">
          No breakdown data for the selected filters.
        </div>
      ) : (
        <div className="h-[260px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData} layout="vertical" margin={{ left: 12, right: 12 }}>
              <CartesianGrid stroke="#EDEEF2" horizontal={false} />
              <XAxis type="number" tick={{ fill: '#8A8EA0', fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis
                type="category"
                dataKey="label"
                width={140}
                tick={{ fill: '#5E6278', fontSize: 11 }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip
                content={
                  <BetaChartTooltip
                    labelFormatter={(label) => String(label)}
                  />
                }
                cursor={{ fill: 'rgba(37, 99, 235, 0.06)' }}
              />
              <Bar
                dataKey="value"
                name="Impressions"
                fill={colour}
                radius={[0, 4, 4, 0]}
                isAnimationActive={false}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </BetaChartCard>
  );
}
